import {Component, Input} from '@angular/core';

import {HelpAboutUsComponent} from "./components/help-about-us/help-about-us.component";
import {HelpReviewsComponent} from "./components/help-reviews/help-reviews.component";
import {HelpUserRatingComponent} from "./components/help-user-rating/help-user-rating.component";
import {HelpPublicCommentsComponent} from "./components/help-public-comments/help-public-comments.component";
import {HelpLikeListingComponent} from "./components/help-like-listing/help-like-listing.component";
import {HelpFollowUserComponent} from "./components/help-follow-user/help-follow-user.component";
import {HelpBlockUserComponent} from "./components/help-block-user/help-block-user.component";

@Component({
  selector: 'nz-general-info',
  standalone: true,
  imports: [
    HelpAboutUsComponent,
    HelpReviewsComponent,
    HelpUserRatingComponent,
    HelpPublicCommentsComponent,
    HelpLikeListingComponent,
    HelpFollowUserComponent,
    HelpBlockUserComponent
  ],
  templateUrl: './general-info.component.html',
  styleUrl: './general-info.component.scss'
})
export class GeneralInfoComponent {
  @Input() subsectionId?: number;
}
